<template>
  <div
    class="funnel-actions-container"
    id="funnel-actions"
    v-if="canReviewExpense && expenseCanBeManaged"
  >
    <template v-if="!isSettingReviewStatus">
      <template v-if="isExpense">
        <div
          class="d-flex approve-container"
          id="approve-content"
          v-if="!isApproved && !isCancelled"
          v-on-clickaway="hideDropdown"
        >
          <button
            class="Fuell-Button Fuell-button--approve green"
            @click="setReviewStatus('APPROVED')"
          >
            <span class="Fuell-Button--label">
              {{ $t(approvedStatusLabel) }}
            </span>
          </button>
          <div class="Fuell-button--approve--divider"></div>
          <div
            class="Fuell-Button Fuell-button--approve-dropdown-container green"
            @click="toggleDropdown"
          >
            <span class="arrow-container">
              <inline-svg :src="arrowDownIcon" />
            </span>
            <div
              class="Fuell-button-approve-dropdown"
              v-if="showDropdown"
            >
              <ul>
                <li @click="showFunnelActionsCommentModal(FUNNEL_COMMENT_ACTIONS.APPROVE)">{{$t('transactions_funnel_actions_approve_with_comments')}}</li>
              </ul>
            </div>
          </div>
        </div>
        <button
          v-if="isApproved && !isCancelled"
          class="Fuell-Button block green green--undo"
          @click="setReviewStatus(REVIEW_STATUS.AWAITING_REVIEW)"
        >
          <span class="Fuell-Button--label"> {{$t('transactions_funnel_actions_approve_undo')}} </span>
        </button>
        <button
          v-if="!isCancelled"
          class="Fuell-Button block red"
          @click="showFunnelActionsCommentModal(FUNNEL_COMMENT_ACTIONS.REJECT)"
        >
          <span class="Fuell-Button--label">
            {{ $t(cancelledStatusLabel) }}
          </span>
        </button>
        <button
          v-if="isCancelled && !isApproved"
          class="Fuell-Button block red red--undo"
          @click="setReviewStatus(REVIEW_STATUS.AWAITING_REVIEW)"
        >
          <span class="Fuell-Button--label"> {{$t('transactions_funnel_actions_undo')}} </span>
        </button>
      </template>
      <template v-else>
        <template v-if="!isPersonalExpense">
          <div
            class="d-flex approve-container"
            v-if="!transactionIsApproved"
            v-on-clickaway="hideDropdown"
          >
            <button
              class="Fuell-Button Fuell-button--approve block green"
              @click="transactionReviewHandler('REVIEW')"
            >
              <span class="Fuell-Button--label">
                {{ $t("transactions_funnel_actions_approve") }}
              </span>
            </button>
            <div class="Fuell-button--approve--divider"></div>
            <div
              class="Fuell-Button Fuell-button--approve-dropdown-container green"
              @click="toggleDropdown"
            >

              <span class="arrow-container">
                <inline-svg :src="arrowDownIcon" />
              </span>
              <div
                class="Fuell-button-approve-dropdown"
                v-if="showDropdown"
              >
                <ul>
                  <li @click="showFunnelActionsCommentModal(FUNNEL_COMMENT_ACTIONS.APPROVE)">{{$t('transactions_funnel_actions_approve_with_comments')}}</li>
                </ul>
              </div>

            </div>

          </div>
          <!--  -->
          <button
            v-else
            class="Fuell-Button block green--undo"
            @click="transactionReviewHandler('UNREVIEW')"
          >
            <span class="Fuell-Button--label">
              {{ $t("transactions_funnel_actions_approve_undo") }}
            </span>
          </button>
        </template>

      <div class="d-flex approve-container"
        v-on-clickaway="hidePersonalExpenseDropdown"
        v-if="!isPersonalExpense"
  >
        <button
          v-if="!isPersonalExpense"
          class="Fuell-Button Fuell-button--approve block red"
          @click="transactionReviewHandler('MARK_AS_PERSONAL')"
        >
          <span class="Fuell-Button--label Fuell-Button--label-personal-expense">
            {{ $t("transactions_funnel_actions_mark_as_personal") }}
          </span>
          </button>
          <div class="Fuell-button--approve--divider"></div>
          <div class="Fuell-Button Fuell-button--approve-dropdown-container red" @click="toggleShowPersonalExpenseDropdown">
            <span class="arrow-container">
              <inline-svg :src="arrowDownIcon" />
            </span>
          <div
              class="Fuell-button-personal-expense-dropdown"
              v-if="showPersonalExpenseDropdown"
            >
              <ul>
                <li @click="showFunnelActionsCommentModal(FUNNEL_COMMENT_ACTIONS.MARK_AS_PERSONAL)">{{$t('transactions_funnel_actions_mark_as_personal_with_comments')}}</li>
              </ul>
            </div>
          </div>

        </div>
        <button
          v-if="isPersonalExpense"
          class="Fuell-Button block red--undo"
          @click="transactionReviewHandler('UNMARK_AS_PERSONAL')"
        >
          <span class="Fuell-Button--label unmark">
            {{ $t("transactions_funnel_actions_unmark_as_personal") }}
          </span>
        </button>
        <button
          class="Fuell-Button Fuell-button--approve Fuell-button--approve--regular block green"
          v-if="isPersonalExpense && !isInOfficeFlow"
          @click="transactionReviewHandler('REVIEW')"
        >
          <span class="Fuell-Button--label">
            {{ $t("transactions_funnel_actions_approve") }}
          </span>
        </button>

      </template>
    </template>
    <template v-else>
      <div class="mx-auto">
        <spinner :spinnerContainerClass="'py-0'" />
      </div>
    </template>

    <funnel-comment-action-modal
      v-if="showFunnelActionsCommentModalFlag"
      :open.sync="showFunnelActionsCommentModalFlag"
      :funnelAction="funnelCommentAction"
      @emitAprovalReason="handleApproveWithComment"
      @emitRejectReason="rejectTransaction"
      @emitMarkAsPersonalReason="markAsPersonalWithComment"
     />

  </div>

</template>

<script>
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import { FUNNEL_COMMENT_ACTIONS } from '../../_constants/FunnelCommentActions'
import { mixin as clickaway } from 'vue-clickaway'

import Spinner from '@/components/Commons/Spinner'
import InlineSvg from 'vue-inline-svg'
import arrowDownIcon from '@/assets/img/icons/icon-arrow-down-white.svg'

const FunnelCommentActionModal = () => import('./FunnelCommentActionModal.vue')

export default {
  name: 'FunnelActions',
  components: { Spinner, FunnelCommentActionModal, InlineSvg },
  mixins: [clickaway],
  props: {
    transactionType: {
      type: String
    },
    reviewStatus: {
      type: [String, Boolean],
      required: true
    },
    expenseOwner: {
      type: [Object, Boolean]
    },
    budgetOwner: {
      type: Boolean,
      required: true
    },
    transactionId: {
      type: [Number, String]
    }
  },

  data () {
    return {
      status: '',
      locked: false,
      isSettingReviewStatus: false,
      REVIEW_STATUS: REVIEW_STATUS,
      showRejectReasonModalFlag: false,
      approvedComment: '',
      showDropdown: false,
      showPersonalExpenseDropdown: false,

      funnelCommentAction: '',
      showFunnelActionsCommentModalFlag: false,
      FUNNEL_COMMENT_ACTIONS: FUNNEL_COMMENT_ACTIONS

    }
  },
  computed: {
    currentLoggedUser () {
      return this.$store.getters['UsersStore/userLogged']
    },
    isExpense () {
      return this.currentTransaction?.type?.code === 'EXPENSE'
    },
    isDraftStatus () {
      return this.reviewStatus === REVIEW_STATUS.DRAFT
    },
    isAwaitingReview () {
      return this.reviewStatus === REVIEW_STATUS.AWAITING_REVIEW
    },
    isApproved () {
      return this.reviewStatus === REVIEW_STATUS.APPROVED
    },
    isCancelled () {
      return this.reviewStatus === REVIEW_STATUS.CANCELLED
    },
    isInOfficeFlow () {
      return this.reviewStatus === REVIEW_STATUS.OFFICE_FLOW_REVISION
    },
    userIsOwner () {
      return (
        this.$store.getters['LoginStore/loggedUserId'] === this.expenseOwner.id
      )
    },
    userIsOwnerOfExpenseBudget () {
      return this.budgetOwner
    },
    reviewUserTasks () {
      return this.currentTransaction?.reviewUserTasks || []
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    expenseCanBeManaged () {
      return (
        this.isAwaitingReview ||
        this.isApproved ||
        this.isCancelled ||
        this.isPersonalExpense ||
        this.isInOfficeFlow
      )
    },
    canReviewExpense () {
      if (this.isApproved || this.isPersonalExpense) {
        return (
          this.isAdmin || this.isBookKeeper || this.userIsOwnerOfExpenseBudget
        )
      }
      const userCanReview = this.reviewUserTasks.find(el => el.user.id === this.currentLoggedUser.id)
      if (userCanReview) {
        return userCanReview.canReviewNextStep
      }
      return false
    },
    showAcceptOrRejectButton () {
      return (
        this.canReviewExpense &&
        (this.isAwaitingReview || this.isCancelled || this.isApproved)
      )
    },
    reviewStatusTypes () {
      return this.$store.getters['ConfigStore/privateConfig']
        ? this.$store.getters['ConfigStore/privateConfig']
          .transaction_review_statuses
        : false
    },
    currentTransaction () {
      return this.$store.getters['TransactionsStore/currentTransaction']
    },
    isPersonalExpense () {
      return this.currentTransaction.isPersonalExpense && this.isApproved
    },

    transactionIsApproved () {
      return (
        this.currentTransaction.type.code === 'NORMAL' &&
        this.isApproved &&
        !this.isPersonalExpense
      )
    },
    approvedReviewStatus () {
      return this.reviewStatusTypes.find((el) => el.code === 'APPROVED')
    },
    cancelledReviewStatus () {
      return this.reviewStatusTypes.find((el) => el.code === 'CANCELLED')
    },
    awaitingReviewStatus () {
      return this.reviewStatusTypes.find((el) => el.code === REVIEW_STATUS.AWAITING_REVIEW)
    },
    approvedStatusLabel () {
      return this.isExpense
        ? 'transactions_funnel_actions_approve'
        : 'transactions_funnel_actions_review'
    },
    cancelledStatusLabel () {
      return this.isExpense
        ? 'transactions_funnel_actions_reject'
        : 'transactions_funnel_actions_unreview'
    },
    arrowDownIcon () {
      return arrowDownIcon
    }
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    hideDropdown () {
      this.showDropdown = false
    },
    toggleShowPersonalExpenseDropdown () {
      this.showPersonalExpenseDropdown = !this.showPersonalExpenseDropdown
    },
    hidePersonalExpenseDropdown () {
      this.showPersonalExpenseDropdown = false
    },
    showFunnelActionsCommentModal (action) {
      this.showFunnelActionsCommentModalFlag = true
      this.funnelCommentAction = action
    },
    handleApproveWithComment (event) {
      this.approvedComment = event
      if (this.isExpense) {
        this.setReviewStatus('APPROVED')
      } else {
        this.transactionReviewHandler('REVIEW')
      }
    },
    async transactionReviewHandler (reviewStatus) {
      if (this.isSettingReviewStatus) return
      let reviewStatusInfo = {}

      if (reviewStatus === 'REVIEW') {
        reviewStatusInfo.reviewStatus = { id: this.approvedReviewStatus.id }
        reviewStatusInfo.isPersonalExpense = false
        reviewStatusInfo.locked = true

        if (this.approvedComment) {
          reviewStatusInfo.notes = this.approvedComment
        }
      }
      if (reviewStatus === 'UNREVIEW') {
        reviewStatusInfo.reviewStatus = { id: this.awaitingReviewStatus.id }
        reviewStatusInfo.locked = false
      }

      if (reviewStatus === 'MARK_AS_PERSONAL') {
        reviewStatusInfo.reviewStatus = { id: this.approvedReviewStatus.id }
        reviewStatusInfo.isPersonalExpense = true
        reviewStatusInfo.locked = true
      }

      if (reviewStatus === 'UNMARK_AS_PERSONAL') {
        reviewStatusInfo.reviewStatus = { id: this.awaitingReviewStatus.id }
        reviewStatusInfo.isPersonalExpense = false
        reviewStatusInfo.locked = false
      }

      this.isSettingReviewStatus = true
      await this.$store.dispatch(
        'TransactionsStore/setTransactionReviewStatus',
        {
          transactionId: this.currentTransaction.id,
          reviewStatus: reviewStatusInfo
        }
      )
      this.isSettingReviewStatus = false
      this.$emit('reviewStatusChanged')
    },

    async setReviewStatus (reviewStatusName) {
      if (this.isSettingReviewStatus) return
      this.isSettingReviewStatus = true

      const reviewStatusType = this.reviewStatusTypes.find(
        (el) => el.code === this.reviewStatus
      )
      if (reviewStatusType) {
        const { allowedTransitions } = reviewStatusType
        if (allowedTransitions.includes(reviewStatusName)) {
          const nextStatusType = this.reviewStatusTypes.find(
            (el) => el.code === reviewStatusName
          )

          if (reviewStatusName === 'CANCELLED') {
            this.isSettingReviewStatus = false
            this.showFunnelActionsCommentModal(FUNNEL_COMMENT_ACTIONS.REJECT)
            return
          }
          if (reviewStatusName === 'APPROVED') {
            this.locked = true
          } else {
            this.locked = false
          }
          let reviewData = {
            reviewStatus: { id: nextStatusType.id },
            locked: this.locked
          }

          if (this.approvedComment && reviewStatusName === 'APPROVED') {
            reviewData['notes'] = this.approvedComment
          }
          await this.$store.dispatch(
            'TransactionsStore/setTransactionReviewStatus',
            { transactionId: this.transactionId, reviewStatus: reviewData }
          )
        } else {
          await this.$store.dispatch(
            'SnackBars/addError',
            this.$t(
              'transactions_funnel_update_status_transition_not_allowed'
            )
          )
        }
      }
      this.$emit('reviewStatusChanged')
      this.isSettingReviewStatus = false
      this._resetStatusAndLockValue()
    },
    async rejectTransaction (rejectReason) {
      if (this.isSettingReviewStatus) return
      this.isSettingReviewStatus = true
      try {
        const cancelledReviewStatus = this.reviewStatusTypes.find(el => el.code === 'CANCELLED')
        const reviewData = {
          reviewStatus: { id: cancelledReviewStatus.id },
          reviewRejectedReason: rejectReason

        }
        await this.$store.dispatch('TransactionsStore/setTransactionReviewStatus', { transactionId: this.transactionId, reviewStatus: reviewData })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_funnel_update_status_transition_not_allowed' })
      } finally {
        this.isSettingReviewStatus = false
      }
    },
    async markAsPersonalWithComment (comment) {
      if (this.isSettingReviewStatus) return
      this.isSettingReviewStatus = true
      try {
        const reviewData = {
          reviewStatus: { id: this.approvedReviewStatus?.id },
          isPersonalExpense: true,
          notes: comment

        }
        await this.$store.dispatch('TransactionsStore/setTransactionReviewStatus', { transactionId: this.transactionId, reviewStatus: reviewData })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_funnel_update_status_transition_not_allowed' })
      } finally {
        this.isSettingReviewStatus = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.green--undo {
  background-color: var(--semantic-positive-main);
  color: var(--text-button);
}
.orange {
  background-color: var(--semantic-alert-main);
  color: var(--text-button);
}
.orange--undo {
  background-color: var(--semantic-alert-main);
  color: var(--text-button);
}
.red {
  background-color: var(--red-action-2-active);
  color: var(--text-button);
}
.red--undo {
  background-color: var(--red-action-2-active);
  color: var(--text-button);
}
.arrow-white {
  filter: invert(99%) sepia(3%) saturate(258%) hue-rotate(193deg)
    brightness(116%) contrast(100%);
}
.arrow-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  & > svg {
    height: 100%;
    position: absolute;
    max-height: 16px;
    left: -6px;
  }
}
.approve-container {
  max-width: 178px;
  width: 100%;
  margin-right: 8px;
  margin-left: 3px;
  position: relative;
}

.Fuell-Button {
  max-width: 178px;
}

.Fuell-button--approve {
  display: flex;
  align-items: center;

  margin-right: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  width: 100%;
  &--regular {
    border-radius: 4px !important;
    margin: 0px !important;
    & > span {
      text-align: center;
      width: 100%;
      margin: 0px !important;
    }
  }
  &--divider {
    // height:24px;
    // width:1px;
    // background-color: #fff;
    height: 24px;
    width: 1px;
    background-color: #fff;
    position: absolute;
    right: 33px;
    z-index: 1;
    top: 7px;
  }
  & > .Fuell-Button--label {
    margin-left: 40px;
  }
}
.Fuell-button--approve-dropdown-container {
  display: block;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  position: relative;
  cursor: pointer;
  max-width: 32px;
  width: 100%;
}
.Fuell-button-approve-dropdown{
  display: block;
  position: absolute;
  background-color: white;
  color: black;
  height: 44px;
  z-index: 999;
  bottom: 44px;
  right: -10px;
  width: 178px;
  border: 1px solid var(--fill-border);
  border-radius: 4px;
  & ul {
    margin: 0px !important;
    padding-inline-start: 0px;
    padding: 3px;
  }
  & ul > li {
    list-style: none;
    padding: 5px;
    color: var(--text-body);
    font-size: 13px;
    cursor: pointer;
    margin: 5px 0px;
    font-weight: 400;
  }
}
.Fuell-button-personal-expense-dropdown {
    display: block;
  position: absolute;
  background-color: white;
  color: black;
  height: 44px;
  z-index: 999;
  bottom: 44px;
  right: -5px;
  width: 210px;
  border: 1px solid var(--fill-border);
  border-radius: 4px;
  & ul {
    margin: 12px  8px!important;
    padding-inline-start: 0px;
  }
  & ul > li {
    list-style: none;
    padding: 0px;
    color: var(--text-body);
    font-size: 13px;
    cursor: pointer;
    margin: 5px 0px;
    font-weight: 400;
  }

}

.funnel-actions-container {
  display: flex;
  flex-direction: flex-row;
  width: 100%;
  max-width: 364px;
  > .Fuell-Button:first-child {
    margin-left: 3px !important;
    margin-right: 8px !important;
  }
  > .Fuell-Button:nth-child(2) {
    margin-left: 0px;
  }
}

.unmark {
  display: inline-block;
  line-height: 15px;
  margin-top: 2px;
}
.Fuell-Button--label-personal-expense {
  margin: 0px!important;
  padding: 8px!important;
}

</style>
